import React from 'react';
import { startCase, upperCase } from 'lodash';
import { cut } from '../utils';

/* eslint-disable react/prop-types */
const CustomerInfo = ({
  customerPhoto,
  customerName,
  customerNameShort,
  customerNotes,
  customerPhone,
  customerEmail,
  customerFirstName,
}) => (
  <div className="c-shop-location">
    {
      customerPhoto && <img className="c-customer-avatar" src={customerPhoto} alt="" />
    }
    {
      !customerPhoto &&
      <div className="c-avatar-placeholder u-mt-6 u-ml-4 u-hide-on-mobile">{upperCase(customerNameShort)}</div>
    }
    {
      !customerPhoto
      && <div className="c-avatar-placeholder u-mt-5 u-mb-5 u-hide-on-desktop">{upperCase(customerNameShort)}</div>
    }
    <div className="u-pt-5 u-pr-4 u-pb-4 u-pl-4 u-flex-1 u-flex u-justify-content-center">
      <div className="u-ta-left">
        <div className="u-text-normal u-fw-bold u-mb-2">
          {startCase(customerName)}
        </div>
        <div className="u-text-small u-co-grey u-mb-5">
          {customerNotes ? cut(customerNotes, 120) : `${startCase(customerFirstName)} doesn't have any custom notes`}
        </div>
        {
          customerPhone && (
            <div className="u-mb-1">
              <a className="u-co-grey u-text-extrasmall u-fw-bold" href={`tel:${customerPhone}`}>
                <img
                  className="c-contact-icon"
                  src="https://squire-emails.s3-us-west-1.amazonaws.com/images/message.png"
                  alt=""
                />
                {customerPhone}
              </a>
            </div>
          )
        }
        {
          customerEmail && (
            <div>
              <a className="u-co-grey u-text-extrasmall u-fw-bold" href={`mailto:${customerEmail}`}>
                <img
                  className="c-contact-icon"
                  src="https://squire-emails.s3-us-west-1.amazonaws.com/images/email.png"
                  alt=""
                />
                Email {startCase(customerFirstName)}
              </a>
            </div>
          )
        }
      </div>
    </div>
  </div>
);

export default CustomerInfo;



// WEBPACK FOOTER //
// ./src/app/notifications/shared/CustomerInfo.jsx